export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}/Index`,
        name: `${prefix}.statement.Index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.statement.Index`,
                PageDescription: "Organization: Payment Report and Statement",
            },
        },
    },
];
